import React, { MouseEvent } from "react";
import cn from "classnames";
import styles from "./round-button-tabs.module.scss";

interface RoundButtonTypes {
  name: string;
  value: string;
  selected: boolean;
}

interface RoundButtonPropTypes {
  button: RoundButtonTypes;
  onClickHandler: (e: MouseEvent, buttonValue: string) => void;
}

interface RoundButtonTabsPropTypes {
  roundButtonTypesArray: RoundButtonTypes[]
  onClickHandler: (e: MouseEvent, buttonValue: string) => void;
}

const cssClassName = "round-button-tabs";

export const RoundButtonTabs = ({ roundButtonTypesArray, onClickHandler }: RoundButtonTabsPropTypes) => {

  const RoundButton = ({ button, onClickHandler }: RoundButtonPropTypes) => {
    return (
      <button
        className={cn(
          styles[`${cssClassName}__button-tab`], {
          [styles[`${cssClassName}__button-tab--selected`]]: button.selected === true
        })}
        onClick={(e) => onClickHandler(e, button.value)}
        key={button.value}
      >
        {button.name}
      </button>
    )
  }

  return (
    <div className={styles[cssClassName]}>
      {roundButtonTypesArray && roundButtonTypesArray.map(button => (
        <RoundButton key={button.value} button={button} onClickHandler={onClickHandler} />
      ))}
    </div>
  )
}
